import {
	Box,
	Button,
	Card,
	CardContent,
	Divider,
	Grid,
	Tab,
	Tabs,
	Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FormType } from '@/api/enum/formType.enum';
import { useState } from 'react';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import AppFieldView from '@/common/components/form-view/AppFieldView';
import RichTextDisplay from '@/common/components/form-view/RichTextDisplay';
import dayjs from 'dayjs';
import { DISPLAY_DATETIME_12H_FORMAT } from '@/utils/dateHelper';
import RuleInfoForm from './components/ExplainForm';
import { useGetExplainPageQuery } from '@/api/treasury/explainApiSlice';

export default function ExplainPage() {
	const { t } = useTranslation();
	const [type, setType] = useState<FormType>(FormType.view);
	const [currentTab, setCurrentTab] = useState('zh');

	const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
		setCurrentTab(newValue);
	};
	const { data: detail } = useGetExplainPageQuery(null, {
		refetchOnMountOrArgChange: true,
	});

	return (
		<>
			<Grid container justifyContent='center'>
				<Grid item xs={12}></Grid>
			</Grid>
			<Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
				<Box sx={{ width: '100%' }}>
					<Box display='flex' justifyContent='space-between'>
						<Typography variant='h4'>
							{t('drawerListItems.explainText')}
						</Typography>
					</Box>
					<Card sx={{ marginTop: 3 }}>
						{(() => {
							switch (type) {
								case FormType.view:
									return (
										<>
											<CardContent sx={{ padding: '24px' }}>
												<Box display='flex' justifyContent='space-between'>
													<Typography variant='h6'>
														{t('meditation.record')}
													</Typography>
												</Box>
												<Grid
													container
													spacing={3}
													marginTop={0}
													marginBottom={3}
												>
													<Grid item xs={6}>
														<AppFieldView
															label={t('ruleList.updateTime')}
															value={
																!detail?.data.updatedAt
																	? '-'
																	: dayjs(detail?.data.updatedAt)
																			.locale('en')
																			.format(DISPLAY_DATETIME_12H_FORMAT)
															}
														/>
													</Grid>
												</Grid>
												<Divider />
												<Box
													display='flex'
													justifyContent='space-between'
													sx={{ paddingTop: '24px' }}
												>
													<Typography variant='h6'>
														{t('meditation.text')}
													</Typography>
													<Button
														endIcon={<CreateOutlinedIcon />}
														color='secondary'
														onClick={() => {
															setType(FormType.edit);
														}}
													>
														{t('button.edit')}
													</Button>
												</Box>
												<Grid
													container
													spacing={3}
													marginTop={0}
													marginBottom={3}
												>
													<Grid item xs={12}>
														<Tabs value={currentTab} onChange={handleTabChange}>
															<Tab
																label={
																	<Typography variant='body1'>
																		{t('meditation.zh')}
																	</Typography>
																}
																value='zh'
															/>
															<Tab
																label={
																	<Typography variant='body1'>
																		{t('meditation.en')}
																	</Typography>
																}
																value='en'
															/>
														</Tabs>
													</Grid>

													{currentTab == 'zh' && (
														<Grid item xs={12}>
															<RichTextDisplay
																editorTheme='style2'
																label={t('ruleList.description')}
																editorStateString={
																	detail?.data.descriptionZh || '-'
																}
															/>
														</Grid>
													)}
													{currentTab == 'en' && (
														<Grid item xs={12}>
															<RichTextDisplay
																editorTheme='style2'
																label={t('ruleList.description')}
																editorStateString={
																	detail?.data.descriptionEn || '-'
																}
															/>
														</Grid>
													)}
												</Grid>
											</CardContent>
										</>
									);
								case FormType.edit:
									return (
										<RuleInfoForm
											type={type}
											setType={setType}
											detail={detail?.data}
										/>
									);
							}
						})()}
					</Card>
				</Box>
			</Box>
		</>
	);
}
